import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { makeAPIRequestReactQuery } from './api';
import { endpoints } from './endpoints';
import type { TTreatment } from './useAppointments';

export const useAppointmentsDetails = ({
  unifiedIds,
  enabled,
}: {
  unifiedIds: string[];
  enabled?: boolean;
}) => {
  const { primaryPracticeId: practiceId, primaryOrganizationId: orgId } =
    useSelector((state: any) => state.login.user);

  const unifiedAppointmentPath = `${practiceId}/${endpoints.appointments}/treatmentsDetails`;

  return useQuery(
    [endpoints.appointments, unifiedIds],
    () =>
      makeAPIRequestReactQuery<AppointmentDetails[]>(
        unifiedAppointmentPath,
        { unifiedAppointmentIds: unifiedIds },
        'get',
        {
          headers: {
            Practice: practiceId,
            Org: orgId,
          },
        },
      ),
    {
      enabled: !!unifiedIds?.length && enabled,
    },
  );
};

export interface AppointmentDetails {
  outstanding: TTreatment[];
  scheduled: TTreatment[];
  unifiedAppointmentId: string;
}
